export default class FormFieldRule {
    public fieldName: string = "";
    public containsValue: string = "";
    public notContainsValue: string = "";
    public setToRequiredIfTrue: boolean | null = null;
    public showIfTrue: boolean | null = null;
}